import { render, staticRenderFns } from "./ShopXqSetting.vue?vue&type=template&id=2f55345e&"
import script from "./ShopXqSetting.vue?vue&type=script&lang=js&"
export * from "./ShopXqSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShopXqSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports